import styled from 'styled-components';

interface IAppProps {
  sidebar: boolean;
}

export const AppContainer = styled.div<IAppProps>`
  display: flex;
  width: 100%;
  height: fit-content;
  min-height: 100%;

  main {
    display: flex;
    flex: 1;
    flex-direction: column;

    height: fit-content;
    min-height: 100vh;
    max-width: calc(100vw - 138.5px);
  }
`;
